import { CHDevice } from "@app/project/model/ch-device";
import { ClassImporterExporter, ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { CommandHelper, EventHandlers } from "./command";
import { DcoCommand, DcoCommandData } from "./dco-command";

export interface DcoOperationCommand extends DcoCommand {
    operation: string;
    args: { [k: string]: any };
}

export interface DcoOperationCommandData extends DcoCommandData {
    operation: string;
    args: { [k: string]: any };
}

export class DcoOperationCommandHelper extends CommandHelper {
    commandType = "DcoOperationCommand";
    device: CHDevice;

    flyoutMenuActions = [];

    registerEventHandlers(handlers: EventHandlers) {
        this.flyoutMenuActions.length = 0;
        if (handlers.edit) {
            this.registerEditHandler(handlers.edit);
        }

        if (handlers.remove) {
            this.registerRemoveHandler(handlers.remove);
        }
    }

    registerEditHandler(emitter) {
        this.flyoutMenuActions.push({ name: "Edit", action: emitter });
    }

    registerRemoveHandler(emitter) {
        this.flyoutMenuActions.push({ name: "Remove", action: emitter });
    }

    static importMap: ImportMap<DcoOperationCommand, DcoOperationCommandData> = [
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "uid", o: "deviceUid" },
        { i: "device_class", o: "deviceClass" },
        { i: "operation", o: "operation" },
        { i: "args", o: "args" },
    ];

    static fromCHObject(command): DcoOperationCommand {
        return ClassImporterExporter.importObject(command, this.importMap);
    }
}
